import React, { SetStateAction, useEffect, useState } from 'react';
import { getInfluencersData } from '../../app/brand/campaign/manage';
import {
    iFilterInfluencers,
    iManageFilters,
    iPlatformIcons,
} from '../../app/brand/campaign/manage/calendar/dto/IManageCalendar';
import { iFilterPlatforms } from '../../app/brand/campaign/manage/calendar/components/CalendarListViewHeader';
import { ManageService } from '../../app/brand/campaign/manage/service';
import { ErrorToast } from '../../utils/toasters';
import { IContentModal } from '../../app/brand/campaign/book/offer/dto/IContentModal';

const getPlatforms = (filterPlatforms: iFilterPlatforms, setState: React.Dispatch<SetStateAction<any>>) => {
    return ManageService.getAdminPlatforms(filterPlatforms)
        .then(response => {
            setState(response.data);
        })
        .catch(error => ErrorToast(error));
};

export const useCalendarFilters = ({ listOfInfluencers, campaignId }: any) => {
    const [filterDropdownPlatforms, setFilterDropdownPlatforms] = useState<iFilterPlatforms>({
        name: '',
        isEnabled: true,
        page: 1,
        perPage: 0,
    });
    const [platformDropdownList, setPlatformDropdownList] = useState<iPlatformIcons[]>([]);
    const [filterModalPlatforms, setFilterModalPlatforms] = useState<iFilterPlatforms>({
        name: '',
        isEnabled: true,
        page: 1,
        perPage: 10,
    });
    const [modalPlatformDropdownList, setModalPlatformDropdownList] = useState<iPlatformIcons[]>([]);
    const [influencerDropdownList, setInfluencerDropdownList] = useState<IContentModal[]>([]);
    const [influencerModalList, setInfluencerModalList] = useState<IContentModal[]>([]);
    const [filterParams, setFilterParams] = useState<iManageFilters>({
        page: 1,
        perPage: 15,
        totalPages: 0,
        sortType: 'DESC',
    });

    const [filterModalInfluencerList, setFilterModalInfluencerList] = useState<iFilterInfluencers>();
    const [filterDropdownInfluencerList, setFilterDropdownInfluencerList] = useState<iFilterInfluencers>({
        page: 1,
        perPage: 0,
    });

    useEffect(() => {
        getPlatforms(filterDropdownPlatforms, setPlatformDropdownList);
    }, [JSON.stringify(filterDropdownPlatforms)]);

    useEffect(() => {
        getPlatforms(filterModalPlatforms, setModalPlatformDropdownList);
    }, [JSON.stringify(filterModalPlatforms)]);

    useEffect(() => {
        if (listOfInfluencers) {
            setInfluencerDropdownList(listOfInfluencers);
            setInfluencerModalList(listOfInfluencers);
        }
    }, [JSON.stringify(listOfInfluencers), JSON.stringify(filterParams)]);

    useEffect(() => {
        getInfluencersData(campaignId, filterModalInfluencerList as iFilterInfluencers, setInfluencerModalList);
    }, [JSON.stringify(filterModalInfluencerList)]);

    useEffect(() => {
        getInfluencersData(campaignId, filterDropdownInfluencerList as iFilterInfluencers, setInfluencerDropdownList);
    }, [JSON.stringify(filterDropdownInfluencerList)]);

    const handleChangeParams = (paramKey: string, paramValue: string | string[], isLongTerm?: boolean) => {
        setFilterParams(prev => ({
            ...prev,
            page: 1,
            [paramKey]: paramValue,
            isLongTerm,
        }));
    };
    return {
        platformDropdownList,
        filterParams,
        modalPlatformDropdownList,
        influencerDropdownList,
        influencerModalList,
        setFilterParams,
        setFilterModalInfluencerList,
        setFilterDropdownInfluencerList,
        setFilterDropdownPlatforms,
        handleChangeParams,
    };
};
